import { defineStyle } from '@chakra-ui/react';

export const transparentVariant = defineStyle({
  background: 'transparent',
  color: 'neutral.white',
  border: '2px solid',
  borderColor: 'blue.600',
  lineHeight: '40px',
  paddingY: 0,
  _placeholder: { color: 'neutral.500', fontWeight: 'medium', fontSize: '14px' },
  _disabled: {
    cursor: 'default',
  },
});
